import { motion } from "framer-motion";
import { Reveal, Overline, EASE } from "./motion";
import { APPLIED } from "./content";

export const BrandApplied = () => (
  <section className="relative overflow-hidden bg-dm-ink py-24 dm-noise md:py-32">
    <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-8">
      <div className="mb-14 max-w-2xl">
        <Reveal>
          <Overline color="#00E676">A marca aplicada</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-display text-5xl font-black leading-[0.9] tracking-tighter text-dm-cream md:text-6xl lg:text-7xl">
            Do quarto à escola,
            <br />
            <span className="dm-rainbow-text">onde a criança está.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-dm-cream/70">
            Da festa ao shopping: o universo continua em cada objeto do dia a dia.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {APPLIED.map((item, i) => (
          <Reveal key={item.label} delay={i * 0.1}>
            <motion.div
              whileHover={{ rotate: 0, y: -8 }}
              initial={{ rotate: item.rot }}
              transition={{ duration: 0.5, ease: EASE }}
              className="group overflow-hidden rounded-[2rem] bg-dm-cream"
            >
              <div className="overflow-hidden">
                <img
                  src={item.img}
                  alt={item.label}
                  className="aspect-square w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
              </div>
              <div className="flex items-center justify-between p-6">
                <span className="font-display text-2xl font-bold tracking-tight text-dm-ink">
                  {item.label}
                </span>
                <span className="max-w-[55%] text-right text-xs font-medium text-dm-muted">
                  {item.desc}
                </span>
              </div>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
